<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='42'>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="'导入时间'">
              <a-range-picker
                v-model='queryParam.createdTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="'通话时间'">
              <a-range-picker
                v-model='queryParam.telTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item :label="'批次No'">
              <a-input
                placeholder="请输入批次No"
                v-model="queryParam.batchNo"/>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item :label="'批次渠道'">
              <a-input
                placeholder="请输入批次渠道"
                v-model="queryParam.batchChannel"/>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item :label="'联系方式'">
              <a-input
                placeholder="请输入联系方式"
                v-model="queryParam.mobileNo"/>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='4'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                      <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                      <a-button type='primary' @click='searchReset' icon='reload'
                                style='margin-left: 8px'>{{ $t('reset')
                        }}</a-button>
                      <a-button type='primary' @click="downLoadData()" icon='download'
                          style='margin-left: 8px'>{{ $t('exportFile')
                  }}</a-button>
                    </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
          <v-pagination
            v-if='total'
            :page-num='form.pageNum'
            :page-size='form.pageSize'
            :total='total'
            @change='handleTableChange' />
        </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import { queryWhiteDetailList } from '@/webpublicapi/ImportWhite'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  FOLLOW: 'importPayoutOrder.'
}
export default {
  name: 'importPayoutOrder',
  components: {},
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      dataSourceTotal: [],
      departments: [],
      groupAll: [],
      normalConfigList: [],
      // 查询条件
      queryParam: {
        batchNo: "",
        batchChannel: "",
        mobileNo: "",
        createdTime: [],
        telTime: []
      },
      limitParam: '',//查询条件
      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      uploadDataParam: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '批次No',
          align: 'center',
          dataIndex: 'batchNo'
        },
        {
          title: '批次渠道',
          align: 'center',
          dataIndex: 'batchChannel'
        },
        {
          title: '联系方式',
          align: 'center',
          dataIndex: 'mobileNo'
        },
        {
          title: '导入时间',
          align: 'center',
          dataIndex: 'createdTime'
        },
        {
          title: '通话时间',
          align: 'center',
          dataIndex: 'telTime'
        }
      ]
    }
  },
  created() {
    // this.getTime()
    this.loadData(1)
  },
  methods: {
    //导出
    async downLoadData () {
      var params = this.getQueryParams()// 查询条件
      this.loading = true;
      try {
        const result = await exportFileByPost(
          '/api/web/webpublic/white/exportWhiteDetailList',
          params,
          //"CollectionTelMarket" + params.createTimeStart  + params.createTimeEnd +'.xlsx',
          "ExternalTrafficWhiteDetailExcel.xlsx"
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally {
            // 无论成功还是失败，都设置 loading 为 false
            this.loading = false;
        }
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.checkbosNum = selectedRows
      console.log('选择了一行数据！！！')
      if (selectedRows.length) {
        this.batchIdNum = selectedRows[selectedRows.length - 1].batchId
        console.log('selectedRowKeys---->', selectedRowKeys)
        console.log('selectedRows--->', selectedRows)
        console.log(' this.batchIdNum--->', this.batchIdNum)
        this.uploadDataParam.batchId = this.batchIdNum
        console.log(' this.uploadDataParam--->', this.uploadDataParam)
      }
    },
    clickUploadFile() {
    },
    QueryOrderChange(e) {
      console.log('下拉框改变了!!!', e)
      this.QueryOrderValue = e
    },
    getHeaders() {
      return getHeaders()
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      //默认加载首页数据
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true;
      var params = this.getQueryParams()// 查询条件
      console.log(params, "请求参数是啥1111");
      
      queryWhiteDetailList(Object.assign({}, params)).then((res) => {
        console.log(res, '加载默认数据列表的接口');
        if (res.code === 1000) {
          this.total = res.data.total;
          this.dataSource = res.data.list;
          console.log('dataSource--->', this.dataSource)
          console.log('this.total', this.total)
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      });
    }
    ,
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const { telTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        createdTimeStart: (createdTime && createdTime.length) ? this.transformTime(createdTime[0]) : undefined,
        createdTimeEnd: (createdTime && createdTime.length) ? this.transformTime(createdTime[1]) : undefined,
        telTimeStart: (telTime && telTime.length) ? this.transformTime(telTime[0]) : undefined,
        telTimeEnd: (telTime && telTime.length) ? this.transformTime(telTime[1]) : undefined
      }

      let param = {
        ...this.queryParam,
        ...data,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      };
      return filterObj(param);
    }
    ,
    transformTime(time) {
      return time && time.format ? time.format('YYYY-MM-DD') : '';
    }
    ,
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    }
    ,
    // 重置搜索框的内容
    searchReset() {
      var that = this;
      that.queryParam.createdTime = [];
      that.queryParam.telTime = [];
      that.queryParam.mobileNo = '';
      that.queryParam.batchNo = '';
      that.queryParam.batchChannel = '';
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
